import { ContactUs } from "../../components/ContactUs";
import { ContactUsStandard } from "../../components/ContactUsStandard";
import { Footer } from "../../components/Footer";
import { IconsRow } from "../../components/IconsRow";
import { VideoSlide } from "../../components/MainSlide";
import { Partner } from "../../components/Partner";
import { ApiScroller } from "../../components/Scroller";
import { TopDescription } from "../../components/TopDescription";
import { WorkWithUs } from "../../components/WorkWithUs";
import { useContattiQuery } from "../../generated/graphql";
import { ServiceDescList } from "./serviceDescList";

function ContactUsServices() {
  const { data } = useContattiQuery();
  return (
    <ContactUs
      blackTheme={true}
      text={data?.contatti?.iscrivitiAlClub || ""}
      url='https://thepadelresort.us14.list-manage.com/subscribe/post?u=fc95bebb5e17453f8c556fef9&amp;id=1dbc49271c&amp;v_id=4825&amp;f_id=006899e5f0'
    />
  );
}
export function Servizi() {
  return (
    <>
      <VideoSlide
        logo='/scrittavideo.webp'
        videoUrl='https://tiglivideo.b-cdn.net/servizi.mp4'
      />
      <TopDescription id='pdMBmOIVpZgYjgAoMK1tO' meta />
      <ServiceDescList></ServiceDescList>
      <IconsRow />
      <TopDescription id='5Hk4gFl3VCuN4Q16TWcBWn' />
      <ApiScroller id='38KtM1DXgpJlXKEuiMnoXw' />

      <ContactUsStandard />
      <ContactUsServices />
      <Partner />
      <WorkWithUs />
      <Footer
        number='+390318180860'
        email='reception@thepadelresort.it'
        prettyNumber='+39 031 8180 860'
      />
    </>
  );
}
